export default "__VITE_ASSET__DhLrnZU5__"